import React from 'react';
import { Fuel } from 'lucide-react';
import ThemeToggle from '../ThemeToggle';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="dashboard-container">
      {/* Dashboard Header */}
      <header className="dashboard-header">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <Fuel className="h-6 sm:h-8 w-6 sm:w-8" style={{ color: 'var(--interactive-primary)' }} />
            <div>
              <h1 className="text-lg sm:text-xl lg:text-lg font-bold" style={{ color: 'var(--text-primary)' }}>
                Octanify
              </h1>
              <p className="text-xs sm:text-sm lg:text-xs hidden sm:block" style={{ color: 'var(--text-secondary)' }}>
                Professional Gas Mix Calculator
              </p>
            </div>
          </div>
          <ThemeToggle />
        </div>
      </header>

      {/* Dashboard Main Content */}
      <main className="dashboard-main">
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;